import { render } from "./TeamAttestationList.vue?vue&type=template&id=9a1626cc&scoped=true"
import script from "./TeamAttestationList.vue?vue&type=script&lang=js"
export * from "./TeamAttestationList.vue?vue&type=script&lang=js"

import "./TeamAttestationList.vue?vue&type=style&index=0&id=9a1626cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1626cc"]])

export default __exports__